import React from 'react';
import intl from 'react-intl-universal';

import { withGlobalData } from '@/utils';
import ContactUS from '@/components/contactUS';

interface IProps {
    baseConfig: any;
}

const ContactUSPage: React.FC<IProps> = (props) => {
    const { baseConfig } = props;

    return <ContactUS baseConfig={baseConfig} />;
};

export const getServerSideProps = withGlobalData(async (params, globalData) => {
    const { baseConfig = {} } = globalData;

    const metaData = {
        title: intl.get('Header.ContactUs').d('联系我们'),
        description: ' ',
        keywords: ' ',
    };

    return { props: { baseConfig, metaData } };
});

export default ContactUSPage;
